import { render } from "./MyPortfolio.vue?vue&type=template&id=64cad47e"
import script from "./MyPortfolio.vue?vue&type=script&lang=js"
export * from "./MyPortfolio.vue?vue&type=script&lang=js"

import "./MyPortfolio.vue?vue&type=style&index=0&id=64cad47e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__